import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Grid, Modal, Row } from 'meitav-uikit';
import './App.css';
import * as Constants from "../../utils/constants";

const SITE_KEY = '6Ldle5QUAAAAAMt8wVG6frcFwZhFbuDakum6TcDB';

export default function Layout({ children }) {
  if (children) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}
        //useEnterprise="true"
        scriptProps={{ async: true }}>
        <Grid layout="join">
          <Modal />
          {children}
          <Row className="accessibilityFooter">
            <a
              className="footer-links"
              target="_blank"
              rel="noreferrer"
              href={Constants.ACCESSIBILITY_LINK}
            >
              הצהרת נגישות
            </a>
          </Row>
        </Grid>
      </GoogleReCaptchaProvider>
    );
  }
  return '';
}
